const sortByDisabledStatus = (arr: Array<any>) => {
  return arr.sort((a, b) => {
    return a.disabled === b.disabled ? 0 : a.disabled ? 1 : -1;
  });
};

export default sortByDisabledStatus;
